import { axiosInstance } from '@/lib/axios'
import { VehiclesResponse, PaginatedVehiclesResponse } from './types'
import { getVehicleType } from 'app/services/delegation/vehicleTypeResolver'

type Props = {
  companyId: string
  page?: number
  pageSize?: number
  groupId?: number
  isActive?: boolean
  search?: string
}

export function getVehiclesList({ companyId, page, pageSize, groupId, isActive, search }: Props) {
  const params = new URLSearchParams();
  
  if (page !== undefined) params.append('page', page.toString());
  if (pageSize !== undefined) params.append('pageSize', pageSize.toString());
  if (groupId !== undefined) params.append('groupId', groupId.toString());
  if (isActive !== undefined) params.append('isActive', isActive.toString());
  if (search !== undefined && search.trim() !== '') params.append('search', search.trim());
  
  const queryString = params.toString();
  const url = `/api/${companyId}/vehicle/list${queryString ? `?${queryString}` : ''}`;
  
  const isPaginated = page !== undefined || pageSize !== undefined;
  
  if (isPaginated) {
    return axiosInstance
      .get<PaginatedVehiclesResponse>(url)
      .then((response) => {
        const { data } = response
        if (data && 'vehicles' in data) {
          return {
            ...response,
            data: {
              ...data,
              vehicles: data.vehicles.map((vehicle) => ({
                ...vehicle,
                vehicleType: getVehicleType(vehicle.vehicleType),
              })),
            },
          }
        }
        return response
      })
  }
  
  return axiosInstance
    .get<VehiclesResponse>(url)
    .then((response) => {
      const { data } = response
      if (Array.isArray(data)) {
        return {
          ...response,
          data: data.map((vehicle) => ({
            ...vehicle,
            vehicleType: getVehicleType(vehicle.vehicleType),
          })),
        }
      }
      return response
    })
}
